export default __webpack_public_path__ + "static/media/hailoffuriousstrikes5.b4ee1b4a.png";